import { useTheme } from '@emotion/react'

import { AppearanceProvider } from '@segment/matcha/foundations/AppearanceContext'

import Footer from '@segment/templates/Footer'
import NavigationV2 from '@segment/templates/Navigation2'

import GettingStarted from '@segment/templates/GettingStarted'

import LayoutBase from '@segment/next-shared/layout'

import Hero from './components/Hero'
import LogoCarousel from './components/LogoCarousel'
import Testimonials from './components/Testimonials'
import UseSegment from './components/UseSegment'
import CollectAndBuild from './components/CollectAndBuild'
import TailoredProduct from './components/TailoredProduct'
import PersonalizeCampaigns from './components/PersonalizeCampaigns'
import SegmentForRetailers from './components/SegmentForRetailers'

import ogImagePng from './assets/OgSegmentIndustryRetail.png'

const IndustryRetailView = () => {
  const theme = useTheme()

  return (
    <AppearanceProvider appearance="twilioLight">
      <LayoutBase
        pageTitle="Industry: Retail | Twilio Segment"
        pageDescription="Unified shopping experiences across online, mobile, in-store, and more..."
        pageOG={ogImagePng}
        themeColor={theme.palette.neutrals.white[100]}
      >
        <NavigationV2 />
        <main>
          <Hero />
          <LogoCarousel />

          <SegmentForRetailers />
          <CollectAndBuild />
          <PersonalizeCampaigns />
          <TailoredProduct />
          <UseSegment />
          <Testimonials />

          <GettingStarted />
        </main>
        <Footer />
      </LayoutBase>
    </AppearanceProvider>
  )
}

export default IndustryRetailView
